import { render, staticRenderFns } from "./FileAttach.vue?vue&type=template&id=21a1884d&scoped=true"
import script from "./FileAttach.vue?vue&type=script&lang=js"
export * from "./FileAttach.vue?vue&type=script&lang=js"
import style0 from "./FileAttach.vue?vue&type=style&index=0&id=21a1884d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a1884d",
  null
  
)

export default component.exports